import "../styles/whatsapp-float.css";

const WHATSAPP_NUMBER = "01010607038";
const WHATSAPP_LINK = "https://wa.me/201010607038";

function WhatsAppFloat() {
  return (
    <a
      className="whatsapp-float"
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="تواصل واتساب لأي مشكلة"
    >
      <span className="whatsapp-float__icon" aria-hidden="true">
        <i className="fab fa-whatsapp"></i>
      </span>
      <span className="whatsapp-float__text">
        <span className="whatsapp-float__label">لأي مشكلة تواصل معنا</span>
        <span className="whatsapp-float__number" dir="ltr">
          {WHATSAPP_NUMBER}
        </span>
      </span>
    </a>
  );
}

export default WhatsAppFloat;
